<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('menu.congelation.stocks')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "CongelationStock",
		mixins: [Navigation],
		data () {
			return {
            }
		},
        computed: {
            swiper_tabs() {
                return [{
                        id: 'not_inventoried',
                        label: 'menu.congelation.not_inventoried',
                        active: false,
                        href : 'CongelationNotInventoried'
                    },
                    {
                        id: 'prestockage',
                        label: 'menu.congelation.prestockage',
                        active: false,
                        href : 'CongelationPrestockage'
                    },
                    {
                        id: 'historique',
                        label: 'menu.congelation.historique',
                        active: false,
                        href : 'CongelationHistorique'
                    },
                    {
                        id: 'import',
                        label: 'menu.congelation.historique_import',
                        active: false,
                        href : 'CongelationStockImport'
                    },
                    {
                        id: 'plan_cuve',
                        label: 'menu.congelation.plan_cuve',
                        active: false,
                        href : 'CongelationPlanCuve'
                    }
                ]
            },
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
